import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense, useEffect } from "react";

import { SITE_NAME } from "@/lib/site";

const StudioScreen = lazy(() =>
  import("@/components/studio/studio-screen").then((m) => ({ default: m.StudioScreen })),
);

export const Route = createFileRoute("/studio")({
  head: () => ({
    meta: [
      { title: `Your studio | ${SITE_NAME}` },
      { name: "description", content: "Private studio for adding handmade doll clothes photos." },
      { name: "robots", content: "noindex, nofollow" },
      { name: "googlebot", content: "noindex, nofollow" },
    ],
  }),
  component: StudioPage,
});

function StudioPage() {
  useEffect(() => {
    document.title = `Your studio | ${SITE_NAME}`;
    const robots = document.querySelector('meta[name="robots"]');
    if (robots) robots.setAttribute("content", "noindex, nofollow");
  }, []);

  return (
    <Suspense
      fallback={
        <main className="mx-auto flex min-h-screen max-w-3xl items-center justify-center px-5 py-20">
          <p className="text-sm text-muted-foreground">Opening the studio…</p>
        </main>
      }
    >
      <StudioScreen />
    </Suspense>
  );
}
